import React from 'react';
import { UseQueryExecute } from 'urql';

import { ActionMenuItemType } from '@lyearn/molecules';
import {
  BaseResourceSchema,
  CheckinType,
  ContentCollectionGroupType,
  ContentEntity,
  ExternalEventContentType,
  HomeworkType,
  KnowledgeAssetContentType,
  LiveEventContentType,
  MicroLearningContentType,
  OfflineEventContentType,
  RecurringExternalEventContentType,
  RecurringLiveEventContentType,
  RecurringOfflineEventContentType,
} from '@/types/schema';

import { UseEventResponseReturnType } from '../../../events/views/EventDetails/hooks/useEventResponse';

export type ContentItemType = Exclude<
  ContentEntity,
  | BaseResourceSchema
  | CheckinType
  | ExternalEventContentType
  | HomeworkType
  | LiveEventContentType
  | OfflineEventContentType
  | RecurringLiveEventContentType
  | RecurringExternalEventContentType
  | RecurringOfflineEventContentType
  | KnowledgeAssetContentType
  | MicroLearningContentType
>;

export type ItemType = ContentItemType | UseEventResponseReturnType | ContentCollectionGroupType;
export enum SharedViaEnum {
  Content = 'content',
  Session = 'session',
  Collection = 'collection',
}

export interface SettingsProps {
  item: ItemType;
  onSubmit: (item: any, action?: DialogsActions) => Promise<boolean> | undefined;
  itemHeader: string;
  config?: DialogsActions[];
  className?: string;
  isSharedItem?: boolean;
  itemType?: SharedViaEnum;
  displayLinks?: boolean;
  allUrls: {
    viewUrl: string;
    manageUrl: string;
  };
  menuItems?: ActionMenuItemType[];
  onMenuItemAction?: (action: string) => void;
  onSuccessCb?: (action: DialogsActions) => void;
  hideArchive?: boolean;
  customItemsPosition?: 'first' | 'last';
  reexecuteQuery?: UseQueryExecute;
}

export interface DialogProps {
  item: ItemType;
  onSubmit: (item: any, action?: DialogsActions) => Promise<boolean> | undefined;
  onClose: () => void;
  itemHeader: string;
  itemType?: SharedViaEnum;
  onSuccessCb?: (action: DialogsActions) => void;
  reexecuteQuery?: UseQueryExecute;
}

export interface MenuProps {
  setActiveDialog: (value: any) => void;
  config: DialogsActions[];
  status: SettingsProps['item']['status'];
  type: SettingsProps['item']['type'];
  isSharedItem: boolean;
  menuItems?: ActionMenuItemType[];
  displayLinks: boolean;
  hideArchive?: boolean;
  customItemsPosition?: SettingsProps['customItemsPosition'];
  isPublicAccessEnabled?: boolean;
  isBlogEnabled?: boolean;
}

export type DialogComponent = React.ComponentType<DialogProps>;

export enum DialogsActions {
  VisibilitySettings = 'VisibilitySettings',
  Tags = 'Tags',
  CopyLearnersLink = 'CopyLearnersLink',
  CopyStaffLink = 'CopyStaffLink',
  RevertChanges = 'RevertChanges',
  UnArchive = 'UnArchive',
  VersionHistory = 'VersionHistory',
  Archive = 'Archive',
  Delete = 'Delete',
  AssignmentRestriction = 'AssignmentRestriction',
  AttachCategories = 'AttachCategories',
  Assign = 'Assign',
  BulkUnAssignContent = 'BulkUnAssignContent',
  ForceComplete = 'ForceComplete',
  Languages = 'Languages',
  EnablePublicAccess = 'EnablePublicAccess',
}
